import React from 'react';

import dayjs from 'utils/extendedDayJS';
import { Separator } from '@epoch-ui/components/Separator';

import { GuestActivityCard } from '../GuestActivityCard';
import { useGuestSideSheetContext } from '../guestSideSheetContext';

export const GuestSideSheetGuestActivitySection = (): React.ReactNode => {
  const {
    guestActivity,
    guestData: { event }
  } = useGuestSideSheetContext();
  if (guestActivity.length === 0) return null;
  const eventTimezone = event.timezoneCode || 'UTC';
  const displayedTimezone = dayjs.tz.guess() || eventTimezone;

  return (
    <>
      <Separator />
      <div className="tw-flex tw-flex-col tw-gap-4">
        <span className="tw-flex tw-items-center tw-text-base tw-font-medium">Guest Activity</span>
        <div className="tw-relative tw-flex tw-flex-col tw-gap-5">
          {/* Vertical timeline connector line */}
          <div className="tw-absolute tw-bottom-0 tw-left-[20px] tw-top-0 -tw-z-10 tw-w-1 tw-bg-background-grey" />

          {guestActivity.map((activity) => (
            <GuestActivityCard key={activity.id} activity={activity} timezone={displayedTimezone} />
          ))}
        </div>
      </div>
    </>
  );
};
